export default __webpack_public_path__ + "static/media/complementary--except-vehicles--g2.a39aee57.png";